module.exports = __webpack_public_path__ + "img/Gauge-Rotor_Force_Direction-Rotating_direction_CW_img01.bdd31a55.svg";